import { api } from '../client'
import type {
  NotificationSettingsGroup,
  UserNotificationSetting,
} from './types'

export async function fetchNotificationSettings() {
  const { data } = await api.get<{ groups: NotificationSettingsGroup[] }>(
    '/notifications/settings',
  )
  return data.groups
}

export async function updateNotificationSettings(
  settings: UserNotificationSetting[],
) {
  const { data } = await api.put('/notifications/settings', settings)
  return data
}
